var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ModuleTable',{attrs:{"icon-mapper":_vm.iconMapper,"modules":_vm.modules,"loading":_vm.areModulesLoading},on:{"delegate-action":_vm.handleTableAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }